export default __webpack_public_path__ + "static/rozmaite-e09acec27bc2f22e9d08f2d7353fd73e.jpg";